import { render, staticRenderFns } from "./TextFragmentList.vue?vue&type=template&id=108103a2&scoped=true"
import script from "./TextFragmentList.vue?vue&type=script&lang=js"
export * from "./TextFragmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108103a2",
  null
  
)

export default component.exports